import { render, staticRenderFns } from "./AnnuityList.vue?vue&type=template&id=0b14aab4&"
import script from "./AnnuityList.vue?vue&type=script&lang=js&"
export * from "./AnnuityList.vue?vue&type=script&lang=js&"
import style0 from "./AnnuityList.vue?vue&type=style&index=0&id=0b14aab4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports